import React from 'react';
import ShortId from 'shortid';
import classnames from 'classnames';
import { withTranslation } from 'react-i18next/src/index';
import PropTypes from 'prop-types';
import Styles from './Phase.module.scss';

const Phase = ({
  phases,
  currentPhase,
  remainingDays,
  hideRemainingInfo,
  t
}) => {
  return (
    <div className={Styles.phase}>
      <ul>
        {phases.map((phase, index) => {
          const completed =
            index < phases.findIndex(phase => phase.name === currentPhase);
          const active = phase.name === currentPhase;
          const className = classnames({
            [Styles.complete]: completed,
            [Styles.active]: active,
            [Styles.inactive]: !completed && !active
          });
          return (
            <li key={ShortId.generate()} className={className}>
              {!hideRemainingInfo && active && (
                <span className={Styles['active-notice']}>
                  <span>
                    <b>{remainingDays}</b>
                    {remainingDays > 1 ? t(' days left') : t(' day left')}
                  </span>
                </span>
              )}
              <span className={Styles.circle} />
              {phase.name}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

Phase.propTypes = {
  phases: PropTypes.array,
  currentPhase: PropTypes.string,
  remainingDays: PropTypes.number,
  hideRemainingInfo: PropTypes.bool,
  t: PropTypes.func
};

export default withTranslation()(Phase);
